export default __webpack_public_path__ + "static/media/upon_my_death_do_this.62d49750.pdf";